export default "https://assets.egbcdn.net/assets/packs/_/images/matches/man-tablet-d22416961525a394b2a480de50287488.png";